import styled from 'styled-components';

export const Content = styled.div`
  padding: 0 4px;
  font-size: 12px;
  line-height: 1.2;
  overflow: hidden;
  width: 2.8ch;
  text-align: right;
  background-color: #12171c;
  color: #7a838a;
  position: absolute;
  left: -2.8ch;
  top: 0;
  border: 1px solid #3d4952;
  border-radius: 10px 0 0 10px;
`;
